<template>
  <!-- 通用二次确认弹窗：支持 ok / warn / danger 三种语气 + 中葡双语 -->
  <el-dialog
    :visible.sync="innerVisible"
    width="460px"
    :show-close="false"
    :custom-class="'confirm-dialog is-' + kind"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="confirm-wrap">
      <div class="cw-head">
        <span class="cw-ico" :class="icoCls">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path v-if="kind === 'danger'" d="M10.3 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.7 3.86a2 2 0 0 0-3.4 0z" />
            <path v-if="kind === 'danger'" d="M12 9v4.4" />
            <circle
              v-if="kind === 'danger'"
              cx="12"
              cy="16.8"
              r="1.1"
              fill="currentColor"
              stroke="none"
            />
            <template v-else>
              <circle cx="12" cy="12" r="10" />
              <path d="M12 7.4v5.6" />
              <circle
                cx="12"
                cy="16.6"
                r="1.15"
                fill="currentColor"
                stroke="none"
              />
            </template>
          </svg>
        </span>
        <div class="cw-title">
          <span>{{ title }}</span>
          <span v-if="titlePt" class="cw-pt">{{ titlePt }}</span>
        </div>
      </div>
      <div class="cw-body">
        <div v-if="subtitle" class="cw-sub">{{ subtitle }}</div>
        <div class="cw-desc" v-html="desc" />
        <div v-if="descPt" class="cw-desc pt" v-html="descPt" />
      </div>
    </div>
    <div slot="footer" class="cw-footer">
      <el-button size="small" @click="innerVisible = false">
        <bi-label zh="取消" pt="Cancelar" inline />
      </el-button>
      <el-button size="small" :type="okType" @click="handleOk">
        {{ okText }}<span v-if="okTextPt" class="btn-pt"> / {{ okTextPt }}</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BiLabel from './BiLabel';

export default {
  name: 'ConfirmDialog',
  components: { BiLabel },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '操作确认' },
    titlePt: { type: String, default: 'Confirmação de Operação' },
    subtitle: { type: String, default: '' },
    desc: { type: String, default: '' },
    descPt: { type: String, default: '' },
    okText: { type: String, default: '确认' },
    okTextPt: { type: String, default: 'Confirmar' },
    kind: { type: String, default: 'ok' } // ok | warn | danger
  },
  computed: {
    /** 弹窗显隐：与父组件 visible 双向绑定（支持 v-model / .sync） */
    innerVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    },
    /** 按语气返回左侧图标配色：danger 红 / warn 橙 / ok 绿 */
    icoCls() {
      if (this.kind === 'danger') return 'is-danger';
      if (this.kind === 'warn') return 'is-warn';
      return 'is-ok';
    },
    /** 确认按钮类型：危险操作用红色，其余用主色 */
    okType() {
      return this.kind === 'danger' ? 'danger' : 'primary';
    }
  },
  methods: {
    /** 点击确认：先抛 confirm 让父组件执行业务，再关闭弹窗 */
    handleOk() {
      this.$emit('confirm');
      this.innerVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .confirm-dialog .el-dialog__header { display: none; }
::v-deep .confirm-dialog .el-dialog__body { padding: 20px; }
::v-deep .confirm-dialog.is-ok { border-top: 3px solid #00a551; }
::v-deep .confirm-dialog.is-warn { border-top: 3px solid #ff7d00; }
::v-deep .confirm-dialog.is-danger { border-top: 3px solid #f53f3f; }
.confirm-wrap {
  padding: 4px 0 0;
}
.cw-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.cw-ico {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cw-ico.is-ok { background: #e8f7f0; color: #00a551; }
.cw-ico.is-warn { background: #fff3e0; color: #ff7d00; }
.cw-ico.is-danger { background: #ffecec; color: #f53f3f; }
.cw-title {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.cw-title .cw-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}
.cw-body {
  padding-left: 36px;
  margin-top: 10px;
}
.cw-sub {
  font-size: 14px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 6px;
}
.cw-desc {
  font-size: 13px;
  color: #4e5969;
  line-height: 1.7;
}
.cw-desc.pt {
  font-size: 12px;
  color: #86909c;
  margin-top: 2px;
}
.btn-pt {
  font-size: 12px;
}
</style>
